import React, {useMemo} from 'react';

import isString from 'lodash.isstring';

import {AvatarWrapped, Size} from '@pb/kit-component-avatar';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group} from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';

import type {UserSearchResult} from 'src/openapi/admin/models/UserSearchResult';

type Props = {
    user: UserSearchResult,
    selectedUsers: (UserSearchResult | string)[],
};

export const UserSuggestItem = ({user, selectedUsers}: Props) => {
    const fullName = useMemo(() => (
        [user.firstName, user.lastName, user.isDeleted ? '(Deleted)' : null].filter(Boolean).join(' ')
    ), [user]);

    return (
        <Group alignItems="center">
            <AvatarWrapped
                alt={user.id.toString()}
                placeholder={Icons.USER}
                size={Size.SMALL}
                name={fullName}
            />
            <div style={{width: 220}}>
                {[user.firstName, user.lastName].join(' ') ? (
                    <EllipsisTextHint title={fullName}>
                        {fullName}
                    </EllipsisTextHint>
                ) : null}
            </div>
            <div style={{width: 220}}>
                {user.email ? (
                    <EllipsisTextHint title={user.email} mix="disabled">
                        {user.email}
                    </EllipsisTextHint>
                ) : null}
            </div>
            {selectedUsers.find(value => isString(value) ? false : value.id === user.id) ? (
                <Icon type={Icons.CHECK}/>
            ) : null}
        </Group>
    );
};
